//original javascript

//ドロップダウンを制御
function hideElement(id) {
  var element = document.getElementById(id);
  if (element) {
    element.classList.add('hidden');
  }
}
function showElement(id) {
  var element = document.getElementById(id);
  if (element) {
    element.classList.remove('hidden');
  }
}
function entryChange1(){
  var select = document.getElementById('deliveryDateSelect');
  var selectedValue = select.value;
  console.log("Selected value:", selectedValue);
  if(selectedValue === "") {
    hideElement('yokuhai-notice');
    hideElement('nichijishitei-notice');
    hideElement('nichijishitei-selector');
    hideElement('haisou-option-notice-b');
    hideElement('haisou-option-notice-c');
  } else if(selectedValue === "翌日お届け") {
    showElement('yokuhai-notice');
    hideElement('nichijishitei-notice');
    hideElement('nichijishitei-selector');
    showElement('haisou-option-notice-b');
    hideElement('haisou-option-notice-c');
  } else if(selectedValue === "日時指定") {
    hideElement('yokuhai-notice');
    showElement('nichijishitei-notice');
    showElement('nichijishitei-selector');
    hideElement('haisou-option-notice-b');
    showElement('haisou-option-notice-c');
  }
}


//配送時間のリセットボタン制御
function resetPullDown(){
    document.forms["frmC"].elements["attributes[delivery-time]"].selectedIndex=0;
}